import React, { useState, useEffect } from 'react';
import "./css/Director.css";

const Chairman = () => {
  const [directorData, setDirectorData] = useState([]);

  console.log("directorDatdirectorDataadirectorData", directorData);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_SCHOOL}/items/admin?fields=*.*&status=published`);
        const data = await response.json();

        console.log("API Response:", data);

        // Map through the data to extract director details
        const directors = data.data.map(director => ({
          directorName: director.name,
          directorMessage: director.message,
          fullUrl: director.image?.data?.full_url, // Make sure to access the image URL properly
          position: director.position,
        }));

        // Update the state with the directors data
        setDirectorData(directors);
      } catch (error) {
        console.error('Error fetching director data:', error);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures useEffect runs once on component mount

  if (directorData.length === 0) {
    return <p>Loading...</p>;
  }

  return (
    <div className="director-sid">
      {directorData.map((director, index) => (
        <div key={index} className="director-sid-row" style={{ marginBottom: "20px" }}>
          {/* Image Column - Left side */}

          <div className="director-sid-col director-info">
            <h4>{director.position}</h4>
            <h6
              dangerouslySetInnerHTML={{
                __html: director?.directorMessage
              }}
            />
          </div>


          <div className="director-sid-col director-image">
            <img
              src={director.fullUrl?.replace('http://', 'https://')}
              alt={director.directorName}
              className="director-image-img"
            />
            <h4>{director.directorName}</h4>

          </div>


        </div>
      ))}
    </div>
  );
};

export default Chairman;
